import * as React from 'react';
import styled from 'styled-components';
import PostPreview, {
  IPostPreviewProps,
} from '../../templates/PostList/PostPreview';
import { IBodyTitle } from '../../utils/types';
import Button from '../Button';
import { textToParagraphs } from '../../utils/strings';
import theme from '../../styles/theme';
import { medias } from '../../styles/helpers/mediaQueries';

export interface IThankYouBlogProps extends IBodyTitle {
  post: IPostPreviewProps;
}

const Wrapper = styled.section`
  max-width: ${theme.containerWidth};
  margin: 4rem auto;
  @media ${medias.tabletMin} {
    display: flex;
    align-items: center;
    > div {
      max-width: 550px;
      margin-right: 1rem;
    }
  }
  @media ${medias.largeMin} {
    > div {
      margin-right: 3rem;
    }
  }
`;

export const ThankYouBlog: React.SFC<IThankYouBlogProps> = props => {
  const { body, title, post } = props;
  return (
    <Wrapper>
      <div>
        <h2>{title}</h2>
        {textToParagraphs(body)}
        <p>
          <Button url="/blog" isSecondary={true}>
            Veja todos os artigos
          </Button>
        </p>
      </div>
      <PostPreview {...post} />
    </Wrapper>
  );
};

ThankYouBlog.displayName = 'ThankYouBlog';

export default ThankYouBlog;
